import eventApi from "../../../services/api/eventApi.js";

const EventApiService = new eventApi();

export default {
  props: ["show", "event"],

  data() {
    return {
      name: "",
      email: "",
      success: false,
      error: false,
      emailRegex:
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    };
  },

  methods: {
    close: close,
    submit: submit,
  },
};

function submit() {
  this.success = false;
  this.error = false;

  if (!this.name) {
    this.error = "Please provide name";

    return;
  }

  if (!this.email || this.emailRegex.test(this.email) === false) {
    this.error = "Please provide valid email address";

    return;
  }

  var request = {
    name: this.name,
    email: this.email,
    event: this.event.fields["Event Name"],
  };

  EventApiService.rsvpToEvent(request)
    .then((response) => {
      if (response.status === 200) {
        this.error = false;
        this.success = true;
        (this.email = ""), (this.name = "");
      }
    })
    .catch((error) => {
      this.error = error.response.message;
    });
}

function close() {
  this.success = false;
  this.error = false;
  this.$parent.isRSVPModalVisible = false;
  this.$router.replace("/events");
}
